import { useEffect, useRef } from 'react';
import Overlay from '../../ui/Overlay';
import { deleteInvitation } from '../../apis/user/user';
import { toast } from 'sonner';
import ModalBox from '../../ui/ModalBox';
import { useLoadingState } from '../../hooks/useLoader';

function DeleteInvitationModal({ close, member, onDelete }) {
    const myRef = useRef({ close });
    const { loading, startLoading, stopLoading } = useLoadingState();
    useEffect(
        function () {
            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );
    return (
        <Overlay>
            <div
                ref={myRef}
                className="absolute rounded-lg left-[50%]     bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
                <ModalBox
                    close={close}
                    onSubmit={async () => {
                        try {
                            startLoading();
                            const { success } = await deleteInvitation(member._id);
                            if (success) {
                                onDelete(member._id);
                                toast.success('Invitation successfully deleted.');
                            }
                        } catch (error) {
                            console.log(error);
                        } finally {
                            close();
                            stopLoading();
                        }
                    }}
                    primaryBtnText={'Delete'}
                    loading={loading}
                    secondaryBtnText={'Cancel'}
                >
                    <>
                        Are you sure you want to <span className="font-bold">delete the invitation sent to {member.userName}</span>?
                    </>
                </ModalBox>
            </div>
        </Overlay>
    );
}

export default DeleteInvitationModal;
